import type { Player } from '../game/types';
import { FarmHouse } from './FarmHouse';
import { Icons } from './Icons';

type Props = {
  players: Player[];
  turn: number;
  lastVictimId: number | null;
  side: 'left' | 'right';
};

export function PlayerPanel({ players, turn, lastVictimId, side }: Props) {
  // 左：偶數 index (0, 2, 4)；右：奇數 index (1, 3)
  const visible = players.filter((_, idx) => (side === 'left' ? idx % 2 === 0 : idx % 2 === 1));
  if (visible.length === 0) return null;

  return (
    <div
      className={`shrink-0 h-full grid content-center gap-[clamp(0.5rem,2vh,1.25rem)] py-2 ${
        side === 'left' ? 'justify-items-start pl-1' : 'justify-items-end pr-1'
      }`}
      style={{ gridTemplateRows: `repeat(${visible.length}, minmax(0, 9rem))` }}
    >
      {visible.map((p) => {
        const idx = players.indexOf(p);
        const isCurrent = idx === turn && !p.isEliminated;
        return (
          <div
            key={p.id}
            className={`@container relative h-full aspect-[5/6] max-h-[9rem] flex flex-col items-center justify-center p-[6%] rounded-2xl transition-all duration-300 farm-border ${p.bgClass} ${
              isCurrent
                ? 'scale-105 z-10 border-green-400 shadow-xl ring-2 ring-green-200'
                : 'border-white shadow-md'
            } ${p.isEliminated ? 'opacity-50 grayscale' : ''}`}
          >
            {isCurrent && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-green-500 text-white text-[10px] px-2 py-0.5 rounded-full animate-bounce shadow whitespace-nowrap z-30">
                Thinking...
              </div>
            )}
            {p.id === lastVictimId && !p.isEliminated && (
              <div
                className="absolute -top-2 -right-2 bg-blue-500 text-white p-1 rounded-full shadow z-20"
                title="保護中"
              >
                <Icons.Shield />
              </div>
            )}
            <div className="text-gray-700 font-black mb-[2%] truncate w-full text-center text-[clamp(0.7rem,14cqh,1.1rem)]">
              {p.name}
            </div>
            <div className="bg-white/80 rounded-full px-[8%] py-[2%] flex items-center gap-1 shadow-inner mb-[3%]">
              <Icons.Apple />
              <span className="text-[clamp(0.875rem,16cqh,1.4rem)] font-black text-gray-700">
                {p.fruits}
              </span>
            </div>
            <div className="w-[55%] aspect-square">
              <FarmHouse colorClass={p.farmColor} />
            </div>
            {p.isEliminated && (
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-red-600 font-black text-[clamp(1rem,22cqh,1.8rem)] rotate-12 border-4 border-red-600 px-2 rounded bg-white/90">
                  OUT
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
